<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('chat.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('chat.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-3 form-group">
            <div class="ts-w-full ts-py-1 ts-flex">
              <input
                type="text"
                v-model="search"
                class="form-control ts-border-r-0 ts-rounded-r-none"
                placeholder="Search"
              />
              <button
                class="ts-w-10 ts-bg-blue-400 ts-text-center ts-rounded-r-sm ts-text-base ts-text-blue-600"
                style="border: 1px solid;after:border: 1px solid"
                @click.prevent="() => (show_modal = true)"
              >
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <ts-loading-banner :loading="loading">
              <div
                class="ts-overflow-y-scroll ts-w-full ts-overflow-x-hidden"
                style="max-height: 62vh; height: 62vh"
              >
                <table class="ts-w-full">
                  <tbody>
                    <tr
                      v-for="(chatRoom, index) in chatRoomLists"
                      :key="index"
                      @click="fetchChatMessage(chatRoom)"
                      class="ts-cursor-pointer hover:ts-bg-gray-300"
                      :class="{
                        active: model.chat_group_id == chatRoom.chat_group_id
                      }"
                      style="height: 50px"
                    >
                      <td class="ts-w-12 with-img">
                        <img
                          class="ts-h-10 ts-w-10 ts-rounded-full"
                          v-lazy="{
                            src: photoChat(chatRoom),
                            error: onError(chatRoom),
                            loading: require('@/assets/Rolling-1s-200px_2.svg')
                          }"
                        />
                      </td>
                      <td class="">
                        <b class="ts-text-xs">
                          {{ chatRoom.full_name }}
                          {{
                            chatRoom.activated_type
                              ? '(' + chatRoom.activated_type + ')'
                              : ''
                          }}
                        </b>
                        <br />
                        <span
                          v-if="chatRoom.last_chat"
                          class="ts-whitespace-no-wrap ts-overflow-hidden"
                          >{{
                            chatRoom.last_chat
                              ? chatRoom.last_chat.send_by
                              : ''
                          }}:
                          {{
                            chatRoom.last_chat
                              ? chatRoom.last_chat.comments.substring(0, 45)
                              : ''
                          }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ts-loading-banner>
            <a-modal
              v-if="show_modal"
              v-model="show_modal"
              :title="$t('chat.newChat')"
              :footer="null"
              :zIndex="1022"
              :maskClosable="false"
              :centered="true"
            >
              <Form @cancel="clearEdit" />
            </a-modal>
          </div>

          <div class="col-lg-9">
            <!-- begin widget-chat -->
            <div class="widget-chat rounded">
              <!-- begin widget-chat-header -->
              <div class="widget-chat-header" v-if="model.chat_group_id">
                <!-- <div class="widget-chat-header-icon" style="padding: -5px">
                  <div class="ts-h-10 with-img ts-w-10">
                    <img
                      class="ts-w-10 ts-h-10 ts-rounded-full"
                      v-lazy="{
                        src: chatPhotos(),
                        error: onError(),
                        loading: require('@/assets/Rolling-1s-200px_2.svg'),
                      }"
                    />
                  </div>
                </div> -->
                <div class="widget-chat-header-content">
                  <h4 class="widget-chat-header-title">
                    {{ chatName }}
                  </h4>
                  <!-- <p class="widget-chat-header-desc">55 members, 4 online</p> -->
                </div>
                <div class="widget-chat-header-content ts-w-1">
                  <a href="#" class="ts-text-black ts-text-center ts-text-lg">
                    <i class="fa fa-info-circle"></i
                  ></a>
                </div>
              </div>
              <!-- end widget-chat-header -->

              <!-- begin widget-chat-body -->
              <ts-loading-banner :loading="loading_comment">
                <div
                  class="widget-chat-body ts-overflow-y-scroll ts-overflow-x-hidden"
                  data-scrollbar="true"
                  style="max-height: 64vh; height: 64vh"
                  ref="containers"
                >
                  <div v-if="!model.chat_group_id" class="text-center">
                    <span class="badge ts-text-xs"
                      >Select a chat to start messaging</span
                    >
                  </div>
                  <div
                    class="ts-w-full"
                    v-for="(chatMessage, index) in chatMessageLists"
                    :key="index"
                  >
                    <div class="text-center text-gray-500 m-3 fw-bold">
                      {{ index }}
                    </div>
                    <div
                      class="ts-w-full ts-h-auto"
                      v-for="(chat, indexc) in chatMessage"
                      :key="indexc"
                    >
                      <div
                        class="widget-chat-item with-media start"
                        v-if="chat.type == '2'"
                        @mouseover="onOver = indexc"
                        @mouseout="onOver = null"
                      >
                        <div class="widget-chat-media">
                          <img
                            class="ts-w-full ts-rounded"
                            v-lazy="{
                              src: chatProfile(chat),
                              error: onError(),
                              loading: require('@/assets/Rolling-1s-200px_2.svg')
                            }"
                          />
                        </div>
                        <div class="widget-chat-info">
                          <div
                            class="widget-chat-info-container ts-break-words"
                            style="max-width: 40%"
                          >
                            <div
                              class="widget-chat-name ts-text-r ts-mb-1"
                              v-if="chat.references != undefined"
                            >
                              <div class="ts-border-l-2 ts-pl-2">
                                <span class="ts-text-blue-600 ts-font-bold">
                                  {{ chat.references.full_name }} </span
                                ><br />
                                <span class="ts-text-black">{{
                                  chat.references.comments
                                }}</span>
                              </div>
                            </div>
                            <div
                              class="widget-chat-name text-indigo ts-flex ts-justify-between"
                            >
                              <span class="ts-font-bold">{{
                                chat.full_name
                              }}</span>
                              <span
                                class="ts-text-white"
                                :class="{
                                  displayss: indexc == onOver
                                }"
                              >
                                <a
                                  href="#"
                                  class="ts-ml-2"
                                  @click.prevent="onReply(chat)"
                                >
                                  Reply
                                </a>
                              </span>
                            </div>
                            <div class="widget-chat-message">
                              {{ chat.comments }}
                            </div>
                            <div class="widget-chat-time">
                              {{ chat.time }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="widget-chat-item end" v-if="chat.type == '1'">
                        <div class="widget-chat-info ts-w-full ts-text-right">
                          <div
                            class="widget-chat-info-container ts-text-left ts-break-words"
                            style="max-width: 40%; background-color: #52a8f3"
                          >
                            <!-- <div class="widget-chat-name ts-text-r">
                            {{ chat.full_name }}
                          </div> -->
                            <div
                              class="widget-chat-name ts-text-r ts-mb-1"
                              v-if="chat.references != undefined"
                            >
                              <div class="ts-border-l-2 ts-pl-2">
                                <span class="ts-text-gray-800 ts-font-bold">
                                  {{ chat.references.full_name }} </span
                                ><br />
                                <span>{{ chat.references.comments }}</span>
                              </div>
                            </div>
                            <div
                              class="widget-chat-message"
                              style="color: white"
                            >
                              {{ chat.comments }}
                            </div>
                            <div class="widget-chat-time" style="color: white">
                              {{ chat.is_read == '0' ? chat.time : '' }}
                              <i
                                class="fas fa-circle-notch spin"
                                v-if="chat.is_read == '2'"
                              ></i>
                              <i
                                class="fa fa-exclamation-circle"
                                v-if="chat.is_read == '3'"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ts-loading-banner>
              <!-- end widget-chat-body -->

              <!-- begin widget-input -->
              <div
                class="ts-p-2 ts-flex ts-justify-between"
                v-if="replyMessage != undefined"
              >
                <div class="ts-text-sm ts-py-1">
                  <span class="text-indigo">
                    {{ replyMessage.full_name }}
                  </span>
                  :
                  <span>{{ replyMessage.comments }}</span>
                </div>
                <div class="ts-h-full ts-pr-3">
                  <a
                    href="#"
                    class="ts-w-full ts-h-full ts-text-center ts-justify-items-center"
                    @click.prevent="replyMessage = null"
                  >
                    <i class="fa fa-times fa-2x"></i>
                  </a>
                </div>
              </div>
              <div class="widget-input" v-if="model.chat_group_id">
                <div class="widget-input-container">
                  <!-- <div class="widget-input-icon">
                    <a href="#" class="text-gray-500"
                      ><i class="fa fa-camera"></i
                    ></a>
                  </div> -->
                  <div class="widget-input-box">
                    <input
                      ref="comments"
                      v-model="model.comments"
                      type="text"
                      class="form-control"
                      placeholder="Write a message..."
                      @keyup.enter="sendMessage()"
                    />
                  </div>
                  <!-- for photo -->
                  <!-- <div class="widget-input-icon">
                    <a href="#" class="text-gray-500"
                      ><i class="fa fa-smile"></i
                    ></a>
                  </div>
                  <div class="widget-input-divider"></div> -->
                  <div class="widget-input-icon">
                    <!-- for voice -->
                    <!-- <a
                      href="#"
                      class="
                        ts-w-10
                        ts-h-10
                        ts-text-black
                        ts-rounded-full
                        ts-text-center
                      "
                      v-if="model.comments == ''"
                    >
                      <i class="fa fa-microphone"></i
                    ></a> -->
                    <a
                      :disabled="disabled"
                      href="#"
                      class="ts-w-10 ts-h-10 ts-text-white ts-rounded-full ts-bg-blue-400 ts-text-center"
                      @click="sendMessage()"
                    >
                      <i class="fa fa-arrow-up"></i>
                      <!-- <i class="fa fa-arrow-up" v-if="!sending"></i>
                      <i class="fas fa-circle-notch spin" v-if="sending"></i> -->
                    </a>
                  </div>
                </div>
              </div>
              <!-- end widget-input -->
            </div>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import Form from './component/form.vue'
// import { debounce, groupBy } from 'lodash'
import moment from 'moment'

export default {
  name: 'chat',
  components: {
    Form
  },
  data () {
    return {
      loading_comment: false,
      sending: false,
      loading: false,
      show_modal: false,
      chatRooms: [],
      chatMessages: [],
      newMessage: [],
      replyMessage: null,
      chatName: '',
      chatPhoto: '',
      onOver: null,
      chat_group_id_old: null,
      model: {
        chat_group_id: null,
        comments: '',
        reference_id: null
      },
      search: '',
      defaultPhoto: require('../../assets/default_user.png')
    }
  },
  computed: {
    disabled () {
      return !(this.sending || this.model.comments != '')
    },
    chatRoomLists () {
      if (!this.chatRooms) {
        return []
      }
      return this.chatRooms.filter(r =>
        this.search
          .split('')
          .every(s => r.full_name.toLowerCase().includes(s.toLowerCase()))
      )
    },
    chatMessageLists () {
      if (!this.chatMessages) {
        return []
      }
      return this.chatMessages
    },
    user_id () {
      return this.$store.state.authUser.user_id
    },
    isStaff () {
      return this.$store.getters.isStaffLogin
    },
    isStudentLogin () {
      return this.$store.getters.isStudentLogin
    },
    isParentLogin () {
      return this.$store.getters.isParentLogin
    },
    ActivatedTypeId () {
      if (this.$store.getters.isStaffLogin) {
        return 6
      }
      if (this.$store.getters.isStudentLogin) {
        return 2
      }
      if (this.$store.getters.isParentLogin) {
        return 1
      }
      return 0
    }
  },
  created () {
    this.listenTraking()
    this.fetchData()
  },
  methods: {
    listenTraking () {
      if (this.user_id && this.ActivatedTypeId) {
        Echo.channel(
          'chat-' + this.user_id + '-' + this.ActivatedTypeId
        ).listen('TrackingChat', e => {
          this.updateChatRoomLists(e)
        })
      }
    },
    updateChatRoomLists (value) {
      let chatIndex = -1
      if (this.isStaff) {
        chatIndex = this.chatRooms.indexOf(
          this.chatRooms.find(
            e => e.chat_group_id == value['staff'].chat_group_id
          )
        )
        if (chatIndex != -1) {
          this.chatRooms.splice(chatIndex, 1)
        }
        this.chatRooms.splice(0, 0, value['staff'])
      }
      if (this.isStudentLogin) {
        chatIndex = this.chatRooms.indexOf(
          this.chatRooms.find(
            e => e.chat_group_id == value['student'].chat_group_id
          )
        )
        if (chatIndex != -1) {
          this.chatRooms.splice(chatIndex, 1)
        }
        this.chatRooms.splice(0, 0, value['student'])
      }
      if (this.isParentLogin) {
        chatIndex = this.chatRooms.indexOf(
          this.chatRooms.find(
            e => e.chat_group_id == value['parent'].chat_group_id
          )
        )
        if (chatIndex != -1) {
          this.chatRooms.splice(chatIndex, 1)
        }
        this.chatRooms.splice(0, 0, value['parent'])
      }
    },
    onReply (chat) {
      this.replyMessage = chat
      this.$refs.comments.focus()
      this.model.reference_id = chat.id
    },
    listen () {
      if (this.model.chat_group_id) {
        Echo.channel('chat-group-' + this.model.chat_group_id).listen(
          'NewChat',
          e => {
            this.addNewMessageFromPusher(e)
            setTimeout(() => this.scrollToEnd(), 100)
          }
        )
      }
    },

    unListen () {
      if (this.model.chat_group_id) {
        Echo.leave('chat-group-' + this.model.chat_group_id)
      }
    },
    unListenTraking () {
      if (this.ActivatedTypeId && this.user_id) {
        Echo.leave('chat-group-' + this.ActivatedTypeId + '-' + this.user_id)
      }
    },
    addNewMessageFromPusher (e) {
      if (e.initiator_id === this.user_id) {
        e.type = 1
      }
      this.newMessage = []
      if (this.chatMessages[e.dates]) {
        this.chatMessages[e.dates].push(e)
      } else {
        this.newMessage.push(e)
        this.chatMessages = Object.assign(
          {},
          this.chatMessages,
          _.groupBy(this.newMessage, 'dates')
        )
      }
    },
    addNewMessage () {
      this.newMessage = []
      let date = moment().format('DD-MM-YYYY')
      this.newMessage.push({
        chat_group_id: this.model.chat_group_id,
        comments: this.model.comments,
        dates: date,
        file_path: null,
        full_name: null,
        id: null,
        is_read: '0',
        mime_type: null,
        photo: null,
        reference_id: null,
        time: moment().format('h:mm a'),
        type: '1',
        references: this.replyMessage
      })
      if (this.chatMessages[date]) {
        this.chatMessages[date].push({
          chat_group_id: this.model.chat_group_id,
          comments: this.model.comments,
          dates: date,
          file_path: null,
          full_name: null,
          id: null,
          is_read: '2',
          mime_type: null,
          photo: null,
          reference_id: null,
          time: moment().format('h:mm a'),
          type: '1',
          references: this.replyMessage
          // sending: true,
        })
      } else {
        this.chatMessages = Object.assign(
          {},
          this.chatMessages,
          _.groupBy(this.newMessage, 'dates')
        )
      }
    },
    photoChat (chatRoom) {
      if (chatRoom.photo) {
        return chatRoom.photo
      }
      return this.defaultPhoto
    },
    chatProfile (chat) {
      if (chat.photo) {
        return chat.photo
      }
      return this.defaultPhoto
    },
    chatPhotos () {
      if (this.chatPhoto) {
        return this.chatPhoto
      }
      return this.defaultPhoto
    },
    onError () {
      return this.defaultPhoto
    },
    clearEdit () {
      this.$store.commit('parentCommunicationChat/SET_EDIT_DATA', {})
      this.show_modal = false
      // this.fetchData()
    },
    async sendMessage () {
      this.sending = true
      if (this.model.comments == '') {
        return
      }
      await this.addNewMessage()
      this.replyMessage = null
      this.$store
        .dispatch('parentCommunicationChat/sendMessage', this.model)
        .then(response => {
          this.model.comments = ''
          this.model.reference_id = ''
          this.messageStatue(0)
          this.sending = false
        })
        .catch(error => {
          this.sending = false
          this.messageStatue(3)
          this.$toasted.error(error.message)
        })
      this.scrollToEnd()
    },
    messageStatue (statue) {
      this.chatMessages[moment().format('DD-MM-YYYY')][
        this.chatMessages[moment().format('DD-MM-YYYY')].length - 1
      ]['is_read'] = statue
    },
    getModel (chatRoom) {
      this.chat_group_id_old = this.model.chat_group_id
      this.chatPhoto = chatRoom.photo
      this.chatName = chatRoom.full_name
      this.model.chat_group_id = chatRoom.chat_group_id
      this.model.comments = ''
    },
    async fetchChatMessage (chatRoom) {
      this.loading_comment = true
      this.replyMessage = null
      this.unListen()
      await this.getModel(chatRoom)
      this.listen()
      this.$store
        .dispatch(
          'parentCommunicationChat/fetch',
          Object.assign({ chat_group_id: this.model.chat_group_id })
        )
        .then(response => {
          this.chatMessages = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading_comment = false
          this.scrollToEnd()
        })
    },
    fetchData () {
      this.loading = true
      this.$store
        .dispatch('parentCommunicationChat/chatroom')
        .then(response => {
          this.loading = false
          this.chatRooms = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    scrollToEnd () {
      var content = this.$refs.containers
      content.scrollTop = content.scrollHeight
    }
  },
  watch: {
    chatMessages: {
      handler () {
        this.scrollToEnd()
      },
      deep: true
    }
  },
  beforeRouteLeave (to, from, next) {
    this.unListenTraking()
    this.$store.commit('parentCommunicationChat/RESET_STATE')
    next()
  }
}
</script>

<style lang="css" scoped>
ul > li > ul {
  margin-left: 40px;
}
.border-reply {
  /* margin-top: -8px; */
  border-left: 1px solid #eaeaea;
  border-bottom-left-radius: 12px;
}
.loading {
  background: #52a8f3;
  height: 3px;
  width: 100%;
  animation: pulse 1s ease infinite alternate,
    nudge 1s ease-out infinite alternate;
}
#container {
  max-height: 75vh;
  overflow: scroll;
}
.form-control {
  outline: none;
}
.active {
  background: #52a8f3;
  color: white;
}
.showButton {
  width: 800px;
}
.notshowbutton {
  width: 1000px;
}
.text-center {
  position: relative;
  top: 45%;
}
.displayss {
  color: grey;
}
@keyframes pulse {
  0% {
    background-color: #ffffff;
  }
  100% {
    background-color: #52a8f3;
  }
}

@keyframes nudge {
  0% {
    transform: translate(100%, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
}
.widget-chat .end .widget-chat-message:before {
  bottom: -5px;
  left: auto;
  right: -24px;
  border-right-width: 0;
  border-right-color: transparent;
  border-left-width: 10px;
  border-left-color: #52a8f3;
}
</style>
